// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";

import Endpoints from "../Endpoints";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## CustomerReport Get
/**
 *
 * @param {{params: object, query: { page: number, search: string, limit: number }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.CustomerReport.GetAll(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};
// ## CustomerReport Create
/**
 *
 * @param {{title: string, description: string}} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.CustomerReport.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## CustomerReport Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.CustomerReport.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## CustomerReport Update
/**
 *
 * @param {{title: string, description: string}} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(
    Endpoints.CustomerReport.Update(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## CustomerReport Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.CustomerReport.Delete(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
};
